import { render, staticRenderFns } from "./Freed.vue?vue&type=template&id=07a56353"
import script from "./Freed.vue?vue&type=script&lang=js"
export * from "./Freed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports